import axios, { AxiosRequestConfig } from 'axios';
import { default as config } from '../../../constants/constants';
import { DocumentType } from '../../../types/Podcast';

export const updateDocumentAPI = async (
  token: string,
  data: DocumentType | { id: string; progress: number }
) => {
  const options: AxiosRequestConfig = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/episodes`,
    data
  };

  return axios(options);
};
// File renamed to episode.ts
